<div class="pending-container w-100">
    <div class="close-modal" (click)="closeModal()"><span>X</span></div>
    <div class="payment-container">
        <div class="title mt-3">
            <ng-container>
                {{ "autorizaciones pendientes" |translate }}
            </ng-container>
        </div>
    </div>
    <div class="description mt-3">
        <p class="text-description">{{"Tienes" |translate}}
            <b>{{pendingAuthPaymentMancomunado ? ("autorizaciones mancomunadas pendientes." |translate) : ("autorizaciones pendientes." |translate)}}</b>
            {{ "Revisalas y" | translate }}
            <b>{{pendingAuthPaymentMancomunado ? ("autorizalas en el apartado de Facultades mancomunadas."|translate) : "autorizalas en el Centro de notificaciones."|translate}}</b>
            </p>
    </div>
    <div class="row button-container mt-3">
            <button
                    type="submit"
                    class="btn-primary mt-3 mb-1 custom-button"
                    (click)="goNotificationCenter()"
                    style="margin-top: 2.25rem;"
            >
                <ng-container >
                    <div style="font-size: 1rem;">
                        <span  class="" role="status" aria-hidden="true"></span>
                        {{pendingAuthPaymentMancomunado ? ("Ir a Facultades mancomunadas" | translate) : ("Ir al Centro de notificaciones" | translate)}}
                    </div>
                </ng-container>

            </button>
        </div>
</div>
